import React ,{useRef} from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { ServiceData } from "../data";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, SplitText);
const ServiceThree = () => {
 const container = useRef();
  useGSAP(
    () => {

      // let split = SplitText.create(".content_para_animation", {
      //   type: "words,chars,lines",
      // });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
          // markers: true
        },
      });
      
       tl.fromTo(
          ".home_service_heading_animation",
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
          
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          },
        ).fromTo(
          ".home_service_card_animation",
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
          
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
  let settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="service-area-2 space-bottom " ref={container}>
      <div className="container ">
        <div className="row align-items-end">
          <div className="col-lg-7">
            <div className="title-area">
              <span className="sub-title home_service_heading_animation">
                <img src="/assets/img/icon/title_left.svg" alt="shape" />
                Our Services
              </span>
              <h2 className="sec-title style2 home_service_heading_animation">Empowering Business
The Excellence</h2>
            </div>
          </div>
          <div className="col-lg-5 home_service_heading_animation">
            <div className="service-title-area">
              <p className="">
             Driving innovation and data-driven strategies to help businesses scale efficiently and achieve sustainable growth in a competitive digital world.

              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid home_service_card_animation">
        <div className="row gx-30 global-carousel service-slider2 ">
          <Slider {...settings} >
            {ServiceData.map((item, index)=>{
              return(
 <div className="p-3" key={index}>
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src={item.icon} alt="img" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to={item.btnLink}>{item.title}</Link>
                  </h4>
                  <p className="service-box_text">
                    {item.des}
                  </p>
                  <Link
                    to={item.btnLink}
                    className="global-btn style-border"
                  >
                    Read More{" "}
                    <img src="/assets/img/icon/right-icon2.svg" alt="Bizmaster" />
                  </Link>
                </div>
              </div>
            </div>
              )
            })}
           
           
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ServiceThree;
